 
import { React, useEffect, useState, Fragment, useCallback, useRef, useMemo, useContext } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, DEFAULT_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PARAMS, ADMIN_ROLE } from "../../Constants";
import { getTemplateByName, genericPost, genericGet, genericPostFileDownload } from "../../services/Api";
import { EbmsLoading, localizeData, getLocalizeData, resetLocalizeData, isObjectEmpty, log, getEncryptedUserData } from "../../services/Utils";

import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import Select from 'react-select';
// import * as d3 from "d3";
import "./styles.css";
import * as FaIcons from 'react-icons/fa';
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FileSaver, saveAs } from 'file-saver';
import * as Alerts from '../customs/Alerts'
import AppContext from "../../AppContext";
import * as XLSX from 'xlsx';
import $ from 'jquery';
import { defaultCss } from "survey-core/plugins/bootstrap-material-integration";
import "survey-creator-core/survey-creator-core.min.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { bootstrapThemeName } from "survey-core/plugins/bootstrap-integration";
import { bootstrapMaterialThemeName } from "survey-core/plugins/bootstrap-material-integration";
import ability from '../../pages/config/defineAbility';
import { PERMS } from '../../pages/config/perms'
// SurveyCore.StylesManager.applyTheme("defaultV2");
SurveyCore.StylesManager.applyTheme("darkblue");

const closeCycleModal = () => {
    const el = document.getElementById("cycle-modal");
    if (!el) return;

    try {
        const Modal = window.bootstrap?.Modal;
        if (Modal) {
            const instance = Modal.getInstance(el) || Modal.getOrCreateInstance(el);
            instance.hide();
        } else {
            el.classList.remove("show");
            el.style.display = "none";
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        el.classList.remove("show");
        el.style.display = "none";
        el.setAttribute("aria-hidden", "true");
    }

    window.setTimeout(() => {
        document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");
    }, 300);
};

const ViewProject = (props) => {
    const history = useHistory();
    const global = useContext(AppContext);

    // Admin detection (same logic as HRMMenu)
    const isAdmin = () => {
        
        try {
            const user = getEncryptedUserData();
            if (!user) return false;
            const userRole = user.role || user.role_id || user.user_id;
          
            return parseInt(userRole) ===  ADMIN_ROLE || userRole ===  ADMIN_ROLE;
        } catch (e) {
            return false;
        }
    };
    const [modal, setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadedSelectionData, setLoadedSelectionData] = useState({});
    const [currentLastSelection, setCurrentLastSelection] = useState({});
    const [componentTypes, setComponentTypes] = useState([]);
    const [enrollments, setEnrollments] = useState([]);
    const [cycles, setCycles] = useState([]);
    const [selected_cycle, setSelected_cycle] = useState(null);
    const [selectedBeneficiaries, setSelectedBeneficiaries] = useState([]);
    const [beneficiariesFormData, setBeneficiariesFormData] = useState({});
    const [updateResponse, setUpdateResponse] = useState(null);
    const [notFoundPhones, setNotFoundPhones] = useState([]);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [isUpdatingComponent, setIsUpdatingComponent] = useState(false);
    const [componentUpdateResponse, setComponentUpdateResponse] = useState(null);
    const [showComponentUpdateModal, setShowComponentUpdateModal] = useState(false);
    const [showCriteriaSummaryModal, setShowCriteriaSummaryModal] = useState(false);
    const [selectedCriteriaSummary, setSelectedCriteriaSummary] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [criteriaSummaryModel, setCriteriaSummaryModel] = useState(null);
    const [criteriaError, setCriteriaError] = useState(null);

    // Admin-only bulk deactivation selection state
    const [selectedBeneficiariesForDeactivation, setSelectedBeneficiariesForDeactivation] = useState([]);
    const [showBulkDeactivateModal, setShowBulkDeactivateModal] = useState(false);
    const [showMasterListJobModal, setShowMasterListJobModal] = useState(false);
    const [masterListJobData, setMasterListJobData] = useState(null);
    const [bulkDeactivateResults, setBulkDeactivateResults] = useState([]);

    // const [cycleModalStatus, setCycleModalStatus] = useState(false);

    const [benTemplate, setBenTemplate] = useState({});
    const [selectedBeneficiary, setBenDetails] = useState({});
    // const [locationModel, setLocationModel] = useState(new SurveyCore.Model({}));
    const [baseTemplateModel, setBaseTemplateModel] = useState(new SurveyCore.Model({}));
    const [baseFilterModel, setBaseFilterModel] = useState(new SurveyCore.Model({}));
    // const [sectorsModel, setSectorModel] = useState(new SurveyCore.Model({}));
    // const [bnfFilterModel, setBnfFilterModel] = useState(new SurveyCore.Model({}));
    const [selectedBeneficiaryModel, setSelectedBeneficiaryModel] = useState(new SurveyCore.Model({}));
    let selectedBnfDetails = {};
    let sectorsModel = new SurveyCore.Model({});
    let bnfFilterModel = new SurveyCore.Model({});
    let fileName = "";
    selectedBeneficiary.editable = false;
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    let data = props.location.state;
    let selection = { "project_id": data };
    // let alertSettings = {};
    const [alertSettings, setAlertSettings] = useState({
        "id": "confirm",
        "type": "warning",
        "title": "<h3>Hey, Are you sure?</h3>",
        "message": "here we go",//"<p>You are about to delete beneficiary named Moses whose telephone is: 6102523233</p>",
        "action": (() => {
            log("This is okay");
        })
    });
    const containerStyle = useMemo(() => ({ width: '100%', height: '100%', backgroundColor: "#ffffff" }), []);
    const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);
    var defaultThemeColors = SurveyCore.StylesManager.ThemeColors["default"];
    defaultThemeColors["$main-color"] = "#7ff07f";
    defaultThemeColors["$main-hover-color"] = "#6fe06f";
    defaultThemeColors["$text-color"] = "#4a4a4a";
    defaultThemeColors["$header-color"] = "#7ff07f";
    defaultThemeColors["$header-background-color"] = "#4a4a4a";
    defaultThemeColors["$body-container-background-color"] = "#f8f8f8";
    //modal confirmation function 
    const confirmAction = () => {
        // log("we are done here", selectedBeneficiary);
    };

    const LoadInfo = async () => {

        // useEffect(() => {
        selection = { ...selection, ...baseFilterModel.data, ...{ "type": "all" } };
        //check sector availability
        if (isObjectEmpty(selection, 'component_type_id')) {
            cogoToast.error("You must select a sector to view the beneficiaries", {});
            return;
        }

        log("FILTER DATA", baseFilterModel.data);
        setCurrentLastSelection(baseFilterModel.data);
        loadProjectInfo({ ...selection, ...baseFilterModel.data });
        // log("File Name: ", loadedSelectionData["project"]["alias"]);
        return () => { };
        // }, []);

    };
    useEffect(() => {

        

        selection = { ...selection, ...{ "type": "summary" } };
        loadProjectInfo(selection);
        // setTimeout(() => {
        //     setBaseFilterModel(loadFilterConfig(sectorsModel,bnfFilterModel)); 
        // }, 5000);
        return () => { };
    }, []);


    useEffect(() => {
       
        if (history.action === "POP") {
          // if back navigation repopulate state from localStorage    
         
          try{
          setTimeout(() => {
            setLoadedSelectionData(JSON.parse(localStorage.getItem("loadedSelectionData")));

          }, 2000);
        
          }catch(e){
alert(e)
          }
        } else {
          // otherwise clear any saved state.
          localStorage.removeItem('loadedSelectionData');
        }
      }, [history.action]);

    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            enableRowGroup: true,
            enablePivot: true,
            enableValue: true,
            sortable: true,
            resizable: true,
            filter: true,
            flex: 5,
            minWidth: 100,
        };
    }, []);

    // baseFilterModel.onValueChanged.add(function (sender, options) {
    //     setCurrentLastSelection({ ...currentLastSelection, ...sender.data });
    //     loadProjectInfo();
    // });
    const loadFilterConfig = (sectorsMod, extraModel) => {

        setIsLoading(true);
        let tempModel = sectorsMod;// new SurveyCore.Model({});
        log("SECTORS DATA: ", sectorsMod.getAllQuestions.length);
        log("LOCS DATA: ", extraModel.getAllQuestions.length);
        // var allAddedQuestions = extraFiltersModel.getAllQuestions();
        let locationPanel = extraModel.getPanelByName("location_details");
        if (locationPanel != null) {
            let allAddedQuestions = locationPanel.questions;
            var page = null;
            if (tempModel != null) {
                page = tempModel.getPage(0);

                if (page != null) {
                    for (var i = 0; i < allAddedQuestions.length; i++) {

                        let qs = allAddedQuestions[i];
                        // if (qs.name !== '2' && qs.name !== 2) {
                        qs.titleLocation = "left";
                        let qCount = page.length;
                        if ((i + 2) % 4 == 0) {
                            qs.startWithNewLine = true;
                        }

                        else {
                            qs.startWithNewLine = false;
                        }

                        qs.allowClear = true;
                        page.addQuestion(qs);
                        // }
                    }
                    // let c = page.getQuestionByName("country");
                    // if (c)
                    //     c.visible = false;
                    log("RESOLVED TEMPLATE: ", "Working");
                    tempModel.pages[0] = page;
                    // page.renderAs="select2";
                    tempModel.widthMode = "responsive";
                    tempModel.showNavigationButtons = false;
                }
            } else {
                log("RESOLVED TEMPLATE: ", "Page is null");
            }
            // baseFilterModel.style = "font-size:40px";

        }
        tempModel.style = { "font-size": "10px" };
        tempModel.widthMode = "responsive";
        tempModel.showNavigationButtons = false;
        setIsLoading(false);

        return tempModel;
    }
    const loadBenTemplate = () => {
        setIsLoading(true);
        genericPost(ENDPOINTS.TEMPLATE_DETAILS, { "template_name": TEMPLATES_URL.BENEFICIARY_TEMPLATE })
            .then((res) => {

                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        let templateData = res.data.data;
                        bnfFilterModel = new SurveyCore.Model(templateData[0]["template"]);
                        // setBnfFilterModel(new SurveyCore.Model(templateData[0]["template"]));
                        setBaseFilterModel(loadFilterConfig(sectorsModel, bnfFilterModel));

                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    const downloadFile = (endpoint, params) => {
        /*  axios({
            method: 'get',
            url: "https://file-examples.com/wp-content/uploads/2017/02/file_example_XLS_10.xls", // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
            responseType: 'stream'
        }).then(function(response){
            FileSaver.saveAs(response.data, "test.xlsx" );
            //  var reader = new FileReader();
            //  reader.readAsDataURL(response.data); 
            //  reader.saveAs();
            // //  reader.onloadend = function() {
            //      var base64data = reader.result;
            //      self.props.onMainImageDrop(base64data)
            //  }
    
        }) */
        setIsLoading(true);
        genericPost("https://filesamples.com/samples/document/xlsx/sample3.xlsx", params)
            .then((res) => {

                setIsLoading(false);
                if (res.status == 200) {
                    FileSaver.saveAs(res.data, "test.xlsx");
                    // const href = URL.createObjectURL(res.data);

                    // // create "a" HTML element with href to file & click
                    // const link = document.createElement('a');
                    // link.href = href;
                    // // link.setAttribute('download', 'file.pdf'); //or any other extension
                    // document.body.appendChild(link);
                    // link.click();

                    // // clean up "a" element & remove ObjectURL
                    // document.body.removeChild(link);
                    // URL.revokeObjectURL(href);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    const deactivateBeneficiary = () => {
        if (!selectedBeneficiary) return;
        const payload = {
            beneficiary_inst_id: selectedBeneficiary["beneficiary_inst_id"],
            child_inst_id: selectedBeneficiary["child_inst_id"],
        };
        log("sendToServer>>", payload);
        setIsLoading(true);
        genericPost(ENDPOINTS.DEACTIVATE_BENEFICIARY, payload)
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        cogoToast.success(res.data.message, {});
                        setBenDetails({});
                        LoadInfo();
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                } else {
                    cogoToast.error("Invalid request. Please try again!", {});
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };

    const bulkDeactivateBeneficiaries = async () => {
        if (!isAdmin() || selectedBeneficiariesForDeactivation.length === 0) return;

        setIsLoading(true);
        try {
            for (let i = 0; i < selectedBeneficiariesForDeactivation.length; i++) {
                const b = selectedBeneficiariesForDeactivation[i];
                const payload = {
                    beneficiary_inst_id: b.beneficiary_inst_id,
                    child_inst_id: b.child_inst_id,
                };
                log("Bulk deactivation payload", payload);
                // eslint-disable-next-line no-await-in-loop
                const res = await genericPost(ENDPOINTS.DEACTIVATE_BENEFICIARY, payload);

                const success = res.status === 200 && res.data.status === SUCCESS_RESULT;
                const message =
                    (res.data && res.data.message) ||
                    (success ? "Deactivated successfully" : "Failed to deactivate");

                // Update results table in modal
                setBulkDeactivateResults((prev) =>
                    prev.map((r) =>
                        r.beneficiary_inst_id === b.beneficiary_inst_id
                            ? {
                                  ...r,
                                  status: success ? "Success" : "Failed",
                                  message,
                              }
                            : r
                    )
                );

                if (success) {
                    // Update local list to reflect deactivation without reloading all data
                    setLoadedSelectionData((prev) => {
                        if (!prev || !prev.list_beneficiaries) return prev;
                        const updated = prev.list_beneficiaries.map((row) =>
                            row.beneficiary_inst_id === b.beneficiary_inst_id
                                ? { ...row, status: 10002 }
                                : row
                        );
                        return { ...prev, list_beneficiaries: updated };
                    });
                }
            }
        } catch (err) {
            console.error(err);
            cogoToast.error("An error occurred while deactivating beneficiaries.", {
                hideAfter: 5,
            });
        } finally {
            setIsLoading(false);
            // Do not close the modal automatically; user will close it manually
            // Keep selectedBeneficiariesForDeactivation so user can see which were processed
        }
    };
    const getChangedFields = (beneficiaryId) => {
        const currentData = beneficiariesFormData[beneficiaryId];
        const originalData = selectedBeneficiaries.find(b => b.beneficiary_inst_id === beneficiaryId);
        if (!currentData || !originalData) return {};
        
        const changedFields = {};
        
        if (currentData.first_name !== originalData.first_name) {
            changedFields.first_name = currentData.first_name;
        }
        if (currentData.middle_name !== originalData.middle_name) {
            changedFields.middle_name = currentData.middle_name;
        }
        if (currentData.last_name !== originalData.last_name) {
            changedFields.last_name = currentData.last_name;
        }
        if (currentData.telephone !== originalData.telephone) {
            changedFields.telephone = currentData.telephone;
        }
        
        return changedFields;
    };

    const isFieldChanged = (beneficiaryId, fieldName) => {
        const currentData = beneficiariesFormData[beneficiaryId];
        const originalData = selectedBeneficiaries.find(b => b.beneficiary_inst_id === beneficiaryId);
        if (!currentData || !originalData) return false;
        return currentData[fieldName] !== originalData[fieldName];
    };

    const getOriginalValue = (beneficiaryId, fieldName) => {
        const originalData = selectedBeneficiaries.find(b => b.beneficiary_inst_id === beneficiaryId);
        if (!originalData) return '';
        return originalData[fieldName] || '';
    };

    const handleBeneficiarySelect = (selectedOptions) => {
        const newBeneficiaries = selectedOptions.map(option => {
            const beneficiary = loadedSelectionData?.list_beneficiaries?.find(b => b.beneficiary_inst_id === option.value);
            return beneficiary;
        }).filter(Boolean);
        
        setSelectedBeneficiaries(newBeneficiaries);
        
        // Initialize form data for selected beneficiaries
        const newFormData = {};
        newBeneficiaries.forEach(ben => {
            newFormData[ben.beneficiary_inst_id] = {
                first_name: ben.first_name || '',
                middle_name: ben.middle_name || '',
                last_name: ben.last_name || '',
                telephone: ben.telephone || ''
            };
        });
        setBeneficiariesFormData(newFormData);
    };

    const updateBeneficiaryField = (beneficiaryId, field, value) => {
        setBeneficiariesFormData(prev => ({
            ...prev,
            [beneficiaryId]: {
                ...prev[beneficiaryId],
                [field]: value
            }
        }));
    };

    const removeBeneficiary = (beneficiaryId) => {
        setSelectedBeneficiaries(prev => prev.filter(b => b.beneficiary_inst_id !== beneficiaryId));
        setBeneficiariesFormData(prev => {
            const newData = { ...prev };
            delete newData[beneficiaryId];
            return newData;
        });
    };

    const handleExcelUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.name.match(/\.(xlsx|xls)$/)) {
            cogoToast.error("Please upload an Excel file (.xlsx or .xls)", {});
            return;
        }

        setIsLoading(true);
        const reader = new FileReader();
        
        reader.onload = (e) => {
            try {
                const arrayBuffer = e.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                
                // Convert to JSON with header row
                const data = XLSX.utils.sheet_to_json(worksheet);
                
                if (data.length === 0) {
                    cogoToast.error("The Excel file is empty", {});
                    setIsLoading(false);
                    return;
                }

                // Validate required columns
                const requiredColumns = ['old_phone', 'new_fisrt_name', 'new_middle_name', 'new_last_name', 'new_phone'];
                const firstRow = data[0];
                const missingColumns = requiredColumns.filter(col => !(col in firstRow));
                
                if (missingColumns.length > 0) {
                    cogoToast.error(`Missing required columns: ${missingColumns.join(', ')}`, {});
                    setIsLoading(false);
                    return;
                }

                // Get all beneficiaries from loadedSelectionData
                const allBeneficiaries = loadedSelectionData?.list_beneficiaries || [];
                
                // Process each row from Excel
                const matchedBeneficiaries = [];
                const newFormData = {};
                const notFoundPhonesList = [];

                data.forEach((row, index) => {
                    const oldPhone = String(row.old_phone || '').trim();
                    
                    if (!oldPhone) {
                        return; // Skip rows without old_phone
                    }

                    // Find beneficiary by telephone (old_phone)
                    const beneficiary = allBeneficiaries.find(ben => 
                        String(ben.telephone || '').trim() === oldPhone
                    );

                    if (beneficiary) {
                        // Check if already added
                        if (!matchedBeneficiaries.find(b => b.beneficiary_inst_id === beneficiary.beneficiary_inst_id)) {
                            matchedBeneficiaries.push(beneficiary);
                            
                            // Populate form data with new values from Excel
                            newFormData[beneficiary.beneficiary_inst_id] = {
                                first_name: String(row.new_fisrt_name || row.new_first_name || beneficiary.first_name || '').trim(),
                                middle_name: String(row.new_middle_name || beneficiary.middle_name || '').trim(),
                                last_name: String(row.new_last_name || beneficiary.last_name || '').trim(),
                                telephone: String(row.new_phone || beneficiary.telephone || '').trim()
                            };
                        }
                    } else {
                        notFoundPhonesList.push(oldPhone);
                    }
                });

                if (matchedBeneficiaries.length === 0) {
                    cogoToast.error("No beneficiaries found matching the phone numbers in the Excel file", {});
                    setIsLoading(false);
                    setNotFoundPhones(notFoundPhonesList);
                    return;
                }

                // Update state with matched beneficiaries and form data
                setSelectedBeneficiaries(prev => {
                    // Merge with existing, avoiding duplicates
                    const existingIds = new Set(prev.map(b => b.beneficiary_inst_id));
                    const newOnes = matchedBeneficiaries.filter(b => !existingIds.has(b.beneficiary_inst_id));
                    return [...prev, ...newOnes];
                });

                setBeneficiariesFormData(prev => ({
                    ...prev,
                    ...newFormData
                }));

                // Store not found phones in state for display
                setNotFoundPhones(notFoundPhonesList);

                // Show success message with summary
                let message = `Successfully loaded ${matchedBeneficiaries.length} beneficiary(ies) from Excel`;
                if (notFoundPhonesList.length > 0) {
                    message += `. ${notFoundPhonesList.length} phone number(s) not found.`;
                }
                cogoToast.success(message, {});

                // Reset file input
                event.target.value = '';
                setIsLoading(false);
            } catch (error) {
                console.error('Excel parsing error:', error);
                cogoToast.error("Error reading Excel file. Please check the file format.", {});
                setIsLoading(false);
            }
        };

        reader.onerror = () => {
            cogoToast.error("Error reading file", {});
            setIsLoading(false);
        };

        reader.readAsArrayBuffer(file);
    };

    const updateBeneficiaryBasicDetails = () => {
        if (selectedBeneficiaries.length === 0) {
            cogoToast.error("Please select at least one beneficiary", {});
            return;
        }

        // Build details array with only changed fields for each beneficiary
        const details = [];
        selectedBeneficiaries.forEach(ben => {
            const changedFields = getChangedFields(ben.beneficiary_inst_id);
            if (Object.keys(changedFields).length > 0) {
                details.push({
                    beneficiary_id: ben.beneficiary_inst_id,
                    ...changedFields
                });
            }
        });

        if (details.length === 0) {
            cogoToast.warn("No fields have been changed for any beneficiary", {});
            return;
        }

        // Get component_id from first beneficiary (assuming all are from same component)
        const componentId = selectedBeneficiaries[0]?.component_id;
        if (!componentId) {
            cogoToast.error("Component ID not found", {});
            return;
        }

        const sendToServer = {
            "component_id": componentId,
            "details": details
        };

        setIsLoading(true);
        setUpdateResponse(null);
        genericPost(ENDPOINTS.UPDATE_BENEFICIARY_BASIC_DETAILS, sendToServer)
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    // Store response to display in modal
                    setUpdateResponse(res.data);
                    
                    if (res.data.status == SUCCESS_RESULT) {
                        cogoToast.success(res.data.message || "Beneficiaries updated successfully", {});
                        
                        // Update local data to avoid reloading only if successful
                        if (loadedSelectionData?.list_beneficiaries && res.data.data) {
                            const updatedBeneficiaries = loadedSelectionData.list_beneficiaries.map(ben => {
                                const updatedData = res.data.data.find(d => d.beneficiary_id === ben.beneficiary_inst_id);
                                if (updatedData && updatedData.status === 'success') {
                                    const formData = beneficiariesFormData[ben.beneficiary_inst_id];
                                    if (formData) {
                                        return {
                                            ...ben,
                                            first_name: formData.first_name,
                                            middle_name: formData.middle_name,
                                            last_name: formData.last_name,
                                            name: `${formData.first_name} ${formData.middle_name} ${formData.last_name}`.trim(),
                                            telephone: formData.telephone
                                        };
                                    }
                                }
                                return ben;
                            });
                            
                            setLoadedSelectionData({
                                ...loadedSelectionData,
                                list_beneficiaries: updatedBeneficiaries
                            });
                            
                            // Refresh grid
                            if (gridRef.current && gridRef.current.api) {
                                gridRef.current.api.setRowData(updatedBeneficiaries);
                            }
                        }
                    } else {
                        // Show error toast but still display response in modal
                        cogoToast.error(res.data.message || "Failed to update beneficiaries", {});
                    }
                } else {
                    cogoToast.error("Invalid request. Please try again!", {});
                    setUpdateResponse(null);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
                cogoToast.error("An error occurred while updating beneficiaries", {});
                setUpdateResponse(null);
            });
    };

    const handleUpdateComponent = () => {
        if (selectedBeneficiaries.length === 0) {
            cogoToast.error("Please select at least one beneficiary", {});
            return;
        }

        if (!selectedComponent) {
            cogoToast.error("Please select a component", {});
            return;
        }

        setIsUpdatingComponent(true);

        // Prepare payload - send beneficiary IDs and component ID
        // Format: { beneficiary_ids: [...], component_id: "..." }
        const payload = {
            beneficiary_ids: selectedBeneficiaries.map(ben => ben.beneficiary_inst_id),
            new_component_id: selectedComponent.value
        };

        genericPost(ENDPOINTS.UPDATE_BENEFICIARY_COMPONENT, payload)
            .then((res) => {
                setIsUpdatingComponent(false);
                if (res.status === 200) {
                    if (res.data.status === SUCCESS_RESULT) {
                        // Store response and show modal
                        setComponentUpdateResponse(res.data);
                        setShowComponentUpdateModal(true);
                        setSelectedComponent(null);
                        // Optionally refresh the data
                        if (selectedBeneficiaries.length > 0) {
                            // Reload project info to get updated data
                            const selection = { ...selection, ...baseFilterModel.data, ...{ "type": "all" } };
                            loadProjectInfo(selection);
                        }
                    } else {
                        cogoToast.error(res.data.message || 'Failed to update component', {});
                    }
                } else {
                    cogoToast.error("Connection error. Please try again.", {});
                }
            })
            .catch((err) => {
                setIsUpdatingComponent(false);
                console.error(err);
                cogoToast.error("Something went wrong, please try again.", {
                    hideAfter: 5,
                });
            });
    };

    const updateBeneficiaryData = () => {
        let updatedModel = selectedBeneficiaryModel.data;
        // updatedModel['project_id'] = selectedBeneficiary['project_id'];
        // updatedModel['component_id'] = selectedBeneficiary['component_id'];
        // updatedModel['beneficiary_inst_id'] = selectedBeneficiary['beneficiary_inst_id'];
        let sendToServer = [{
            "beneficiaryregistrationproject_id": selectedBeneficiary['project_id'],
            "component_id": selectedBeneficiary['component_id'],
            "beneficiary_inst_id": selectedBeneficiary['beneficiary_inst_id'],
            "child_inst_id": selectedBeneficiary['child_inst_id'],

   
            "sync_token": selectedBeneficiary['sync_token'],
            // "beneficiary_details": {"beneficiary_form_details":JSON.stringify(updatedModel)}
            "beneficiary_details": { "beneficiary_form_details": updatedModel }
        }];
        log("sendToServer>>", sendToServer);
        setIsLoading(true);
        genericPost(ENDPOINTS.UPDATE_BENEFICIARY, sendToServer)
            .then((res) => {

                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        let responseData = res.data.data;
                        responseData = responseData[0];
                        if (responseData['status'] === SUCCESS_RESULT) {
                            cogoToast.success(responseData['message'], {});
                            setBenDetails({})
                            setSelectedBeneficiaryModel(new SurveyCore.Model({}));
                            // LoadInfo();
                        }

                        else {
                            cogoToast.error(responseData['message'], {});
                        }


                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                } else {
                    cogoToast.error("Invalid request. Please try again!", {});
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    const loadProjectInfo = (selection) => {
        // setModal(true);
        // return;
        setIsLoading(true);
        log("DATA TO SERVER: ", selection);
        genericPost(ENDPOINTS.PROJECT_DASHBOARD, selection)
            .then((res) => {

                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        cogoToast.success(res.data.message, {});
                        setLoadedSelectionData(res.data.data);
                        if(res.data.data?.list_beneficiaries){
                            localStorage.setItem("loadedSelectionData",JSON.stringify(res.data.data));
                        }


                        log("BNF DATA: ", res.data.data);
                        let sectors = (res.data.data)["project_sectors"];
                        let allSectors = [];
                        let allEnrollments = [];
                        for (var a = 0; a < sectors.length; a++) {
                            let sector = sectors[a];
                            allSectors.push({
                                "value": sector["sector_id"],
                                "text": sector["sector_name"],
                                // "visibleIf": "{zone} =='Somaliland'"
                            });
                            let enrollments = sector["enrollments"];
                            if (enrollments.length !== 0) {
                                for (var b = 0; b < enrollments.length; b++) {
                                    let enrollment = enrollments[b];
                                    allEnrollments.push({
                                        "value": enrollment["enrollment_id"],
                                        "text": enrollment["enrollment_name"],
                                        "visibleIf": "{component_type_id} =='" + sector["sector_id"] + "'"
                                    });
                                }
                            }

                        }
                        setComponentTypes(allSectors);
                        setEnrollments(allEnrollments);
                        let model = new SurveyCore.Model({
                            "logoPosition": "right",
                            "focusOnFirstError": false,
                            "showPageTitles": false,
                            "showCompletedPage": false,
                            "showQuestionNumbers": "off",
                            "questionTitleLocation": "left",
                            "pages": [
                                {
                                    "name": "page1",
                                    "elements": [
                                        {
                                            "type": "dropdown",
                                            "name": "component_type_id",
                                            "title": "Sector",
                                            "startWithNewLine": false,
                                            "titleLocation": "left",
                                            "choices": allSectors
                                        },
                                        {
                                            "type": "dropdown",
                                            "name": "component_id",
                                            "startWithNewLine": false,
                                            "visibleIf": "{component_type_id} notempty",
                                            "title": "Reg Cycle",
                                            "titleLocation": "left",
                                            "choices": allEnrollments
                                        }
                                    ]
                                }
                            ]
                        });

                        setBaseTemplateModel(model);
                        // setSectorModel(model);
                        sectorsModel = model;
                        // setBaseFilterModel(loadFilterConfig(sectorsModel,bnfFilterModel)); 
                        loadBenTemplate();
                        // setTimeout(() => {
                        //     log("LOADING BNF TEMPLATE","BNF Template now loading");
                        //    
                        // }, 3000);
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                } else {
                    cogoToast.error("An error occurred while making request.", {});
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                cogoToast.error("Something went wrong, please Try again. ", {});
            });
    };

    const onBtExport = useCallback(() => {
        setIsLoading(true);
        
        try {
            // Get all row data - prefer from grid API, fallback to loadedSelectionData
            let allRowData = [];
            
            if (gridRef.current && gridRef.current.api) {
                // Get all nodes from grid (works across pagination)
                gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
                    if (node.data) {
                        allRowData.push(node.data);
                    }
                });
            }
            
            // Fallback: use rowData directly if grid API doesn't have data
            if (allRowData.length === 0 && loadedSelectionData && loadedSelectionData["list_beneficiaries"]) {
                allRowData = loadedSelectionData["list_beneficiaries"] || [];
            }

            if (allRowData.length === 0) {
                cogoToast.error("No data available to export", { hideAfter: 3 });
                setIsLoading(false);
                return;
            }

            // Get all column definitions
            const columnDefs = (gridRef.current && gridRef.current.api) 
                ? (gridRef.current.api.getColumnDefs() || [])
                : [];
            const columnHeaders = {};
            const columnOrder = [];
            
            // Build header mapping and order from column definitions
            columnDefs.forEach((colDef) => {
                if (colDef.field) {
                    const headerName = colDef.headerName || colDef.field
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    columnHeaders[colDef.field] = headerName;
                    columnOrder.push(colDef.field);
                } else if (colDef.headerName === "#" || colDef.headerName === "No.") {
                    // Handle row number column
                    columnOrder.push("#");
                }
            });

            // Prepare Excel data with proper column order
                const excelData = allRowData.map((row, index) => {
                const excelRow = {};

                // Helper to safely get nested values like "criteria_summary.score"
                const getNestedValue = (obj, path) => {
                    if (!obj || !path) return "";
                    const parts = path.split(".");
                    let current = obj;
                    for (let i = 0; i < parts.length; i++) {
                        if (current == null) return "";
                        current = current[parts[i]];
                    }
                    return current !== null && current !== undefined ? current : "";
                };
                
                // Add columns in the order they appear in the grid
                columnOrder.forEach((field) => {
                    if (field === "#") {
                        excelRow["#"] = index + 1;
                    } else {
                        const headerName = columnHeaders[field] || field;
                        // Support nested field paths (e.g., "criteria_summary.score")
                        const value = field.includes(".")
                            ? getNestedValue(row, field)
                            : row[field];
                        excelRow[headerName] = value !== null && value !== undefined ? value : "";
                    }
                });
                
                // Add any remaining fields that weren't in column definitions
                Object.keys(row).forEach((key) => {
                    if (!columnHeaders[key] && !excelRow[key]) {
                        const headerName = key
                            .split('_')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');
                        excelRow[headerName] = row[key] !== null && row[key] !== undefined ? row[key] : "";
                    }
                });
                
                return excelRow;
            });

            // Create workbook and worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(excelData);
            
            // Add worksheet to workbook
            const sheetName = "Data Snapshot";
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
            
            // Generate filename
            const projectName = !isObjectEmpty(loadedSelectionData, "project") 
                ? loadedSelectionData["project"]["project_name"] 
                : "Project";
            const sanitizedProjectName = projectName.replace(/[^a-z0-9]/gi, '_');
            const fileName = `${sanitizedProjectName}_Data_Snapshot_${new Date().toISOString().split("T")[0]}.xlsx`;
            
            // Write file
            XLSX.writeFile(wb, fileName);
            
            cogoToast.success("Data exported to Excel successfully", { hideAfter: 3 });
        } catch (error) {
            console.error("Export error:", error);
            cogoToast.error("Failed to export data. Please try again.", { hideAfter: 5 });
        } finally {
            setIsLoading(false);
        }
    }, [loadedSelectionData]);

    const surveyCss = {
        actionBar: {
            root: "sd-action-bar custom-actionbar-root",
        },
        navigation: {
            complete: "sd-btn--action sd-navigation__complete-btn custom-btn btn-info",
            prev: "sd-navigation__prev-btn custom-btn",
            next: "sd-navigation__next-btn custom-btn",
            start: "sd-navigation__start-btn custom-btn",
            preview: "sd-navigation__preview-btn custom-btn",
        },


    }
    const getMasterList = (e) => {
        e.preventDefault();
        // log('FormData:', e.target.cycle.value);
        let cycle_id = "";
        let masterlist_type=e.target.masterlist_type.value;
        let template_status=e.target.template_status.value;
        let start_date=e.target.start_date.value;
        let end_date=e.target.end_date.value;
 


        if (e.target.cycle != undefined && e.target.cycle != null)
            cycle_id = e.target.cycle.value;
        if (cycle_id == "" || cycle_id == undefined || cycle_id == null) {
            cycle_id = "";
        }
if(cycle_id=="" || masterlist_type==""){
    cogoToast.error("Please select cycle & master list  Type ", {});
    return;
}
        
        let selectionFilterData = { ...selection, ...baseFilterModel.data, ...{ "component_cycle_id": cycle_id,"masterlist_type":masterlist_type,template_status:template_status,start_date:start_date,end_date:end_date } };
        if (isObjectEmpty(selectionFilterData, 'project_id') || isObjectEmpty(selectionFilterData, 'component_id')) {
            cogoToast.error("You must select the filter data including the component.: ", {});
            return;
        }//get file name

        let question1 = baseFilterModel.getQuestionByName("component_type_id");
        let question2 = baseFilterModel.getQuestionByName("component_id");
        fileName = (isObjectEmpty(loadedSelectionData, "project")) ? "" : loadedSelectionData["project"]["alias"];
        question1.choices.forEach(choice => {
            if (choice['value'] == selectionFilterData['component_type_id']) {
                fileName += "_" + choice['text'];
                return;
            }
        }); question2.choices.forEach(choice => {
            if (choice['value'] == selectionFilterData['component_id']) {
                fileName += "_" + choice['text'];
                return;
            }
        });
        //add timestamp
        let dat = new Date();
        fileName += "_" + dat.getTime();
        // log("File Name: ", fileName);
        setIsLoading(true);
        log("Exporting Data: ", selectionFilterData);
        genericPost(ENDPOINTS.EXPORT_DATA, selectionFilterData)
            .then((res) => {
                setIsLoading(false);
                if (
                    res.status === 200 &&
                    (res.data.status === SUCCESS_RESULT || res.data.status === DEFAULT_RESULT)
                ) {
                    const jobData = res.data.data || null;
                    closeCycleModal();
                    setMasterListJobData(jobData);
                    window.setTimeout(() => {
                        setShowMasterListJobModal(true);
                    }, 350);
                    cogoToast.success(res.data.message || "Masterlist export queued successfully.", {
                        hideAfter: 4,
                    });
                } else {
                    cogoToast.error(res.data?.message || "Failed to queue masterlist export", {});
                }
            })
            .catch((err) => {
                setIsLoading(false);
                cogoToast.error("An error occurred while queueing masterlist export: " + err, {});
            });
    };

    const formatMasterlistJobDate = (value) => {
        if (!value) return "—";
        try {
            return new Date(value).toLocaleString("en-GB", {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        } catch {
            return value;
        }
    };

    const formatMasterlistJobType = (value) => {
        const v = String(value ?? "");
        if (v === "10000") return "Registration MasterList";
        if (v === "10001") return "Attendance MasterList";
        return value || "—";
    };

    const formatMasterlistJobLocation = (location) => {
        if (!location) return "—";
        const parts = String(location)
            .split("-")
            .map((p) => p.trim())
            .filter(Boolean);
        return parts.length > 0 ? parts.join(" → ") : location;
    };

    const goToMasterListTracker = () => {
        if (!masterListJobData?.queue_job_id) return;
        setShowMasterListJobModal(false);
        history.push({
            pathname: `/projects/masterlist-job-tracker/${encodeURIComponent(masterListJobData.queue_job_id)}`,
            state: { job: masterListJobData },
        });
    };
    const LoadProjectCycles = () => {

        let selectionFilterData = { ...selection, ...baseFilterModel.data };
        if (isObjectEmpty(selectionFilterData, 'project_id') || isObjectEmpty(selectionFilterData, 'component_id')) {
            cogoToast.error("You must select the filter data including the component.: ", {});
            return;
        }
        setIsLoading(true);
        //get the registered cycles Send component_id
        genericPost(ENDPOINTS.PROJECT_CYCLES, selectionFilterData)
            .then((res) => {

                setIsLoading(false);
                if (res.status == 200) {

                    if (res.data.status == SUCCESS_RESULT) {
                        setCycles(res.data.data);
                    } else {
                        cogoToast.error(res.data.message, {});
                        return;
                    }
                }
                // setTimeout(() => {
                //     // $("#cycle-modal").modal('show');  

                // }, 1000);
            })
            .catch((err) => {
                setIsLoading(false);
                cogoToast.error("An error occurred while loading your cycles " + err, {});
                return;
            });

    }
    const toggle = () => setModal(!modal);
    const launchBNFDetails = () => {
        setModal(true);
        if ((isObjectEmpty(loadedSelectionData, "bnf_template")) || loadedSelectionData['bnf_template'] == null || loadedSelectionData['bnf_template'] == "null") {
            cogoToast.error("Enrollment Cycle rights holders template is not available. Please select the Reg Cycle and filter the beneficiaries.", {});
            return;

        }

    };

    return (
        <div>
            <Breadcrumb style={{ backgroundColor: '#ffffff' }} className="ms-1 p-2">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem >
                    <Link to="/projects"> PROJECTS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    <Link to="/"> VIEW PROJECT   </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    <Link to="/"> {(isObjectEmpty(loadedSelectionData, "project")) ? "" : loadedSelectionData["project"]["project_name"]} </Link>
                </BreadcrumbItem>

            </Breadcrumb>
            <div style={containerStyle}>
                <div style={{ marginRight: "0px", marginLeft: "0px" }} className="row ">
                    <div class="pull-left">
                        <Survey style="backgroundColor:#ffffff" model={baseFilterModel} data={currentLastSelection} />
                        <div style={{ marginTop: "0px", marginBottom: "0px" }} class="pull-right">
                            <div style={{ border: "5px" }} >
                                <div class="btn btn-primary btn-l dropend">
                                    <span class="" onClick={LoadInfo} role="button" aria-expanded="false">
                                        <center><span style={{ color: "#ffffff" }}><i class="fa fa-search"></i>&nbsp;Filter Rights Holders</span></center>
                                        {/* <span class="badge badge-sm bg-green-lt text-uppercase ms-auto">New</span> */}
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "0px" }} className="row">
                    {/* <div class="col-12"> */}
                    <div class="col">
                        <div class="card radius-10 border-start border-0 border-3 border-danger">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <p class="mb-0 text-secondary">Project Sectors</p>
                                        <h4 class="my-1 text-danger">{(isObjectEmpty(loadedSelectionData, "project_sectors")) ? 0 : loadedSelectionData["project_sectors"].length}</h4>
                                        {/* <p class="mb-0 font-13">+5.4% from last week</p> */}
                                    </div>
                                    <div class="widgets-icons-2 rounded-circle bg-gradient-bloody text-white ms-auto"><i class="fa fa-circle" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card radius-10 border-start border-0 border-3 border-info">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <p class="mb-0 text-secondary">Total BNF</p>
                                        <h4 class="my-1 text-info">{(isObjectEmpty(loadedSelectionData, "list_beneficiaries")) ? 0 : loadedSelectionData["list_beneficiaries"].length}</h4>
                                        {/* <p class="mb-0 font-13">+2.5% from last week</p> */}
                                    </div>
                                    <div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto"><i class="fa fa-group"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card radius-10 border-start border-0 border-3 border-warning">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <p class="mb-0 text-secondary">Active Data Collectors</p>
                                        <h4 class="my-1 text-info">{(isObjectEmpty(loadedSelectionData, "active_enumerators")) ? 0 : loadedSelectionData["active_enumerators"]}</h4>
                                        {/* <p class="mb-0 font-13">+8.4% from last week</p> */}
                                    </div>
                                    <div class="widgets-icons-2 rounded-circle bg-gradient-blooker text-white ms-auto"><i class="fa fa-group"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card radius-10 border-start border-0 border-3 border-success">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <p class="mb-0 text-secondary">Total Cards issued</p>
                                        <h4 class="my-1 text-info">{(isObjectEmpty(loadedSelectionData, "total_cards")) ? 0 : loadedSelectionData["total_cards"]}</h4>
                                        {/* <p class="mb-0 font-13">-4.5% from last week</p> */}
                                    </div>
                                    <div class="widgets-icons-2 rounded-circle bg-gradient-ohhappiness text-white ms-auto"><i class="fa fa-credit-card"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
                {/* <div className="row">
                    <center><EbmsLoading data={isLoading} /></center>
                </div> */}
                <div className='row'>
                    <div className="card-body">
                        <center><EbmsLoading data={isLoading} /></center>
                        <div class="pull-right">
                            <div style={{ border: "2px" }} >
                                <div class="btn btn-green btn-sm dropend">
                                    <span class="dropdown-item dropdown-toggle" href="#sidebar-cards" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false">
                                        <span style={{ color: "#ffffff" }}>More Actions</span>
                                        {/* <span class="badge badge-sm bg-green-lt text-uppercase ms-auto">New</span> */}
                                    </span>
                                    <div class="dropdown-menu">
                                        {/* <a href="./cards.html" class="dropdown-item">
                                            Enrollment Cycles
                                        </a>
                                        <a href="./card-actions.html" class="dropdown-item">
                                            Distribution Cycles
                                        </a>
                                        <a href="./card-actions.html" class="dropdown-item">
                                            Data Collectors
                                        </a>
                                        <a href="javascript:void(0)" onClick={onBtExport} class="dropdown-item">
                                            Data officer Signoff
                                        </a>
                                        <a href="javascript:void(0)" onClick={onBtExport} class="dropdown-item">
                                            Meal officer Signoff 
                                        </a> */}
                                        
                                        {ability.can(PERMS.READ, PERMS.EXPORT_SNAPSHOT) && (
                                                   
                                        
                                        <a href="javascript:void(0)" onClick={onBtExport} class="dropdown-item">
                                            Export Current Data Snapshot
                                        </a>

                                        )}

{ability.can(PERMS.READ, PERMS.GENERATE_MASTER_LIST) && (
                                         
                                        <a href="javascript:void(0)" onClick={LoadProjectCycles} on data-bs-toggle="modal" data-bs-target="#cycle-modal" class="dropdown-item">
                                            Get Master List.
                                        </a>
 )}

{ability.can(PERMS.READ, PERMS.MANAGE_COMPONENTS) && (
                                        <a href="javascript:void(0)" onClick={() => {
                                            history.push({
                                                pathname: "/projects/components",
                                                state: { project: selection }
                                            });

                                        }} class="dropdown-item">
                                            Project Components
                                        </a>  )}

{ability.can(PERMS.READ, PERMS.VIEW_BNF_MAP) && (

                                        <a href="javascript:void(0)" onClick={() => {
                                            if(!loadedSelectionData["list_beneficiaries"]){
                                                cogoToast.error("Please load data first.", {});

                                                return;

                                            }
                                            history.push({
                                                pathname: "/projects/MapViewer",
                                                state: { project: loadedSelectionData["list_beneficiaries"] }
                                            });

                                        }} class="dropdown-item">
                                            Registration Map 
                                        </a> )}


{ability.can(PERMS.READ, PERMS.VIEW_PROJECT_WORKFLOW) && (

                                        <a href="javascript:void(0)" onClick={() => {
                                           
                                            history.push({
                                                pathname: "/project/workflows",
                                                state: { project: loadedSelectionData["project"] }
                                            });

                                        }} class="dropdown-item">
                                            Project Workflow 
                                        </a> )}

{ability.can(PERMS.READ, PERMS.VIEW_PROJECT_WORKFLOW) && (
                                        <a href="javascript:void(0)" onClick={() => {
                                            const componentId = baseFilterModel.data?.component_id;
                                            if (!componentId) {
                                                cogoToast.error("Please select a component first", {});
                                                return;
                                            }
                                            
                                            // Get component name from the filter model
                                            let componentName = "";
                                            const componentQuestion = baseFilterModel.getQuestionByName("component_id");
                                            if (componentQuestion) {
                                                const selectedComponent = componentQuestion.choices?.find(
                                                    choice => choice.value === componentId
                                                );
                                                componentName = selectedComponent?.text || "";
                                            }
                                            
                                            const projectName = loadedSelectionData["project"]?.alias || loadedSelectionData["project"]?.name || "";
                                            
                                            history.push({
                                                pathname: "/projects/failed-criterion",
                                                state: { 
                                                    component_id: componentId,
                                                    component_name: componentName,
                                                    project_name: projectName
                                                }
                                            });
                                        }} class="dropdown-item">
                                            View Failed Criterion
                                        </a> )}


                                        {/* <a href="javascript:void(0)" onClick={
                                            () => {
                                                downloadFile(ENDPOINTS.EXPORT_DATA,{
                                                    "project_id": "6048b2e2-b735-11ed-8e9a-0a9ea65235cc",
                                                    "component_id": "1a0c0952-b736-11ed-8e9a-0a9ea65235cc",
                                                    "component_cycle_id": "97d3c85e-b742-11ed-8e9a-0a9ea65235cc",
                                                    "zone": "South Central(SC)",
                                                    "region": 9
                                                })
                                            }} class="dropdown-item">
                                            Export Master List
                                        </a> */}
                                        {/* export data */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "0px" }} className="grid-wrapper">
                    {/* <div style={gridStyle} className="ag-theme-alpine"> */}
                    <h2 class="text-blue">RIGHTS HOLDERS SUMMARY DETAILS</h2>

                    {/* Admin bulk actions toolbar */}
                    {isAdmin() && selectedBeneficiariesForDeactivation.length > 0 && (
                        <div className="mb-2 d-flex justify-content-end">
                            <button
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                    // Initialize results table in modal
                                    const initialResults = selectedBeneficiariesForDeactivation.map((b) => ({
                                        beneficiary_inst_id: b.beneficiary_inst_id,
                                        name: `${b.first_name || ""} ${b.middle_name || ""} ${b.last_name || ""}`.trim(),
                                        status: "Pending",
                                        message: "",
                                    }));
                                    setBulkDeactivateResults(initialResults);
                                    setShowBulkDeactivateModal(true);
                                }}
                            >
                                Deactivate Selected ({selectedBeneficiariesForDeactivation.length})
                            </button>
                        </div>
                    )}

                    <div
                        className="ag-theme-alpine"
                        style={{
                            height: "90vh",
                            width: "100%"
                        }}
                    >

                    {loadedSelectionData?.list_beneficiaries!=null ? 
                        <AgGridReact
                            rowSelection={isAdmin() ? "multiple" : "single"}
                            suppressRowClickSelection={isAdmin()}
                            rowMultiSelectWithClick={isAdmin()}
                            onSelectionChanged={(event) => {
                                if (!isAdmin()) return;
                                const selectedRows = event.api.getSelectedRows() || [];
                                setSelectedBeneficiariesForDeactivation(selectedRows);
                            }}
                            suppressMenuHide={true}
                            ref={gridRef}
                            overlayLoadingTemplate={
                                '<div class="card-body text-end placeholder-glow"> <div class="placeholder col-9 mb-3"></div><div class="placeholder placeholder-xs col-10"></div><div class="placeholder placeholder-xs col-12"></div><div class="placeholder placeholder-xs col-11"></div> <div class="placeholder placeholder-xs col-8"></div><div class="placeholder placeholder-xs col-10"></div></div>'
                            }
                        
                        
                            onGridReady={(params) => {
                                setGridApi(params.api);
                                // params.api.showLoadingOverlay();
                            }}

                            onRowClicked={(e)=>{
                               console.clear();
                               console.log(e.data);

                            }}
onRowDoubleClicked={(e)=>{

    if(ability.can(PERMS.UPDATE, PERMS.UPDATE_BENEFICIARY) )
        {
            let data = e.data;
console.clear();
console.log(data);

history.push({
pathname: "/projects/update-beneficiary",
state:  { child_inst_id:data.child_inst_id, beneficiary_inst_id:data.beneficiary_inst_id,component_id:data.component_id,project_id:data.project_id},
});
        }
       
}}

                            rowData={loadedSelectionData["list_beneficiaries"]}
                            domLayout={"autoHeight"}
                            animateRows={true}
                            pagination={true}
                            paginationPageSize={50}
                            defaultColDef={defaultColDef}
                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellSelection={true}
                            masterDetail={true}
                            columnDefs={[
                                // Admin-only selection checkbox column
                                {
                                    headerName: "",
                                    field: "select",
                                    width: 40,
                                    pinned: "left",
                                    sortable: false,
                                    filter: false,
                                    suppressMenu: true,
                                    checkboxSelection: (params) => isAdmin(),
                                    headerCheckboxSelection: isAdmin(),
                                    headerCheckboxSelectionFilteredOnly: true,
                                },
                                {
                                    headerName: "Action",
                                    field: "action",
                                    width: 100,
                                    sortable: false,
                                    filter: false,
                                    //suppressMovable: true,
                                    cellRendererFramework: (e) => {

                                        return (

                                        
                                            <span>
                                               {ability.can(PERMS.UPDATE, PERMS.UPDATE_BENEFICIARY) && (

                                                <span onClick={() => {
                                                    setSelectedBeneficiaries([]);
                                                    setBeneficiariesFormData({});
                                                    setUpdateResponse(null);
                                                    setEditModal(true);
                                                }} className="level-top">
                                                    <FaIcons.FaEdit  
                                                        style={{
                                                            color: "#305176",
                                                            cursor: "pointer",
                                                            fontSize: "1.5em"
                                                        }}
                                                       
                                                    />
                                                </span>)}
                                                &nbsp;&nbsp;
                                                {ability.can(PERMS.DELETE, PERMS.DELETE_BENEFICIARY) && (
                                                <span
                                                    onClick={() => {
                                                        let data = e.data;
                                                        setTimeout(() => {
                                                            setBenDetails(data);
                                                        }, 2000);

                                                    }}
                                                    className="level-top">
                                                    <FaIcons.FaTrashAlt
                                                        data-bs-toggle="modal" data-bs-target="#deactivateBNF"
                                                        style={{
                                                            color: "#AC4425",
                                                            cursor: "pointer",
                                                            fontSize: "1.5em"
                                                        }}

                                                    />
                                                </span>)}
                                            </span>
                                        );
                                    }
                                }
,
                                {
                                    headerName: "#",
                                    filter: false,
                                    maxWidth: 70,
                                    sortable: true,
                                    // checkboxSelection: true,
                                    valueFormatter: function (params) {
                                        return `${parseInt(params.node.id) + 1}`;
                                    },
                                }
                              
                                // {
                                //     headerName: " B-ID ",
                                //     field: "beneficiary_inst_id",
                                //     sortable: true,
                                //     filter: true,
                                //     visible:global.get_logged_in_user().id == 712 || global.get_logged_in_user().id == 474,
                                // },
                                // {
                                //     headerName: " CH-ID ",
                                //     field: "child_inst_id",
                                //     sortable: true,
                                //     filter: true,
                                //     visible:global.get_logged_in_user().id == 712 || global.get_logged_in_user().id == 474,
                            
                                // }
                                
                                ,{
                                    headerName: "Registered On",
                                    field: "registered_on",
                                    sortable: true,
                                    filter: 'agDateColumnFilter',
                                    // type: ['re', 'nonEditableColumn']
                                },
                                
                                {
                                    headerName: " Name ",
                                    field: "name",
                                    sortable: true,
                                    filter: true,
                                }, {
                                    headerName: " Gender ",
                                    field: "gender",
                                    sortable: true,
                                    filter: true,

                                }, {
                                    headerName: "Age",
                                    field: "age",
                                    sortable: true,
                                    // filter: true,
                                    filter: 'agNumberColumnFilter'

                                }, {
                                    headerName: "Card Issued",
                                    field: "card_label",
                                    sortable: true,
                                    filter: true,

                                }
                                , {
                                    headerName: "Telephone",
                                    field: "telephone",
                                    sortable: true,
                                    filter: true,
                                },
                                {
                                        headerName: "Region",
                                        field: "region_name",
                                        sortable: true,
                                        filter: true,
                                    },
                                {
                                        headerName: "District",
                                        field: "district_name",
                                        sortable: true,
                                        filter: true,
                                    } ,
                                       {
                                            headerName: "Village",
                                            field: "village_name",
                                            sortable: true,
                                            filter: true,
                                        },
                                        {
                                            headerName: "Camp ",
                                            field: "camp_name",
                                            sortable: true,
                                            filter: true,
                                            visible:global.get_logged_in_user().id == 712 || global.get_logged_in_user().id == 474,
                            
                                        },
                                // {
                                //     headerName: "HH profile",
                                //     field: "hh_profile",
                                //     sortable: true,
                                //     filter: true,
                                //     hide:true

                                // }
                                // ,
                                // {
                                //     headerName: "Economic situation",
                                //     field: "hh_econ",
                                //     sortable: true,
                                //     filter: true,
                                //     hide:true

                                // },
                                // {
                                //     headerName: "Sector Specific Issues",
                                //     field: "hh_sector_issues",
                                //     sortable: true,
                                //     filter: true,
                                //     hide:true

                                // },
                                // {
                                //     headerName: "Access to services",
                                //     field: "hh_services_access",
                                //     sortable: true,
                                //     filter: true,
                                //     hide:true

                                // },
                                // {
                                //     headerName: "Coping Mechanism",
                                //     field: "hh_coping",
                                //     sortable: true,
                                //     filter: true,
                                //     hide:true
                                // },
                                // {
                                //     headerName: "Score",
                                //     field: "score",
                                //     sortable: true,
                                //     filter: true,
                                //     hide:true

                                // }

       // , {
                                //     headerName: "Region",
                                //     field: "region_name",
                                //     sortable: true,
                                //     filter: true,
                                // } , {
                                //     headerName: "District",
                                //     field: "district_name",
                                //     sortable: true,
                                //     filter: true,
                                // } , {
                                //     headerName: "Village",
                                //     field: "village_name",
                                //     sortable: true,
                                //     filter: true,
                                // }

                                // , {
                                //     headerName: "Enrollment",
                                //     field: "enrollment_type",
                                //     sortable: true,
                                //     filter: true,
                                // }  , {
                                //     headerName: "Institution Name",
                                //     field: "institution_name",
                                //     sortable: true,
                                //     filter: true,
                                // }
                                // , {
                                //     headerName: "Institution Location",
                                //     field: "institution_location",
                                //     sortable: true,
                                //     filter: true,
                                // }
                                // , {
                                //     headerName: "Institution Telephone",
                                //     field: "institution_telephone",
                                //     sortable: true,
                                //     filter: true,
                                // }
                                
                                {
                                    headerName: "Criteria",
                                    field: "criteria_summary.score",
                                    sortable: true,
                                    filter: true,
                                    cellRendererFramework: (params) => {
                                        const score = params.data?.criteria_summary?.score || params.value || '';
                                        const criteriaSummary = params.data?.criteria_summary;
                                        
                                        return (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span>{score}</span>
                                                {criteriaSummary && (
                                                    <FaIcons.FaInfoCircle
                                                        style={{
                                                            color: "#007bff",
                                                            cursor: "pointer",
                                                            fontSize: "16px"
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedCriteriaSummary(criteriaSummary);
                                                            setSelectedRowData(params.data);
                                                            setCriteriaError(null);
                                                            setShowCriteriaSummaryModal(true);
                                                        }}
                                                        title="View Criteria Summary"
                                                    />
                                                )}
                                            </div>
                                        );
                                    }
                                }
                                ,

                                {
                                    headerName: "Registered By",
                                    field: "created_by_name",
                                    sortable: true,
                                    filter: true,
                                }
                                ,
                                // {
                                //     headerName: "Manual Card",
                                //     field: "manual_card_label",
                                //     sortable: true,
                                //     // type: ['re', 'nonEditableColumn']
                                // }
                                // ,
                                {
                                    headerName: "Updated On",
                                    field: "updated_on",
                                    sortable: true,
                                    filter: 'agDateColumnFilter',
                                    // type: ['re', 'nonEditableColumn']
                                }
                                , {
                                    headerName: "zero_5_male_with",
                                    field: "zero_5_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "zero_5_male_without",
                                    field: "zero_5_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "zero_5_female_with",
                                    field: "zero_5_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "zero_5_female_without",
                                    field: "zero_5_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "six_12_male_with",
                                    field: "six_12_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "six_12_male_without",
                                    field: "six_12_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "six_12_female_with",
                                    field: "six_12_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "six_12_female_without",
                                    field: "six_12_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },{
                                    headerName: "thirteen_17_male_with",
                                    field: "thirteen_17_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "thirteen_17_male_without",
                                    field: "thirteen_17_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },

                                {
                                    headerName: "thirteen_17_female_with",
                                    field: "thirteen_17_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "thirteen_17_female_without",
                                    field: "thirteen_17_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighteen_29_male_with",
                                    field: "eighteen_29_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighteen_29_male_without",
                                    field: "eighteen_29_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighteen_29_female_with",
                                    field: "eighteen_29_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighteen_29_female_without",
                                    field: "eighteen_29_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "thirty_49_male_with",
                                    field: "thirty_49_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "thirty_49_male_without",
                                    field: "thirty_49_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "thirty_49_female_with",
                                    field: "thirty_49_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,
                                {
                                    headerName: "thirty_49_female_without",
                                    field: "thirty_49_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "fifty_69_male_with",
                                    field: "fifty_69_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "fifty_69_male_without",
                                    field: "fifty_69_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "fifty_69_female_with",
                                    field: "fifty_69_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "fifty_69_female_without",
                                    field: "fifty_69_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                
                                
                                {
                                    headerName: "seventy_79_male_with",
                                    field: "seventy_79_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "seventy_79_male_without",
                                    field: "seventy_79_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "seventy_79_female_with",
                                    field: "seventy_79_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "seventy_79_female_without",
                                    field: "seventy_79_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                
                                {
                                    headerName: "eighty_above_male_with",
                                    field: "eighty_above_male_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighty_above_male_without",
                                    field: "eighty_above_male_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighty_above_female_with",
                                    field: "eighty_above_female_with",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "eighty_above_female_without",
                                    field: "eighty_above_female_without",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                               
                                
                                {
                                    headerName: "total_hh_male",
                                    field: "total_hh_male",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                },
                                {
                                    headerName: "total_hh_female",
                                    field: "total_hh_female",
                                    sortable: true,
                                    filter: true,
                                    hide: false
                                }
                                ,

                            ]
                            }
                        ></AgGridReact> :<center><h1>No Data</h1></center>
                    }
                      
                        <Modal
                            // className="modal-lg"
                            isOpen={modal} toggle={toggle}>
                            <ModalHeader
                                // cssModule={{
                                //     fontSize: "100px",
                                //     color: "#4a54f1",
                                //     paddingTop: "0px",
                                //     'modal-title': 'w-100 text-center'
                                // }} 
                                toggle={toggle}><center>RIGHTS-HOLDERS DETAILS</center></ModalHeader>
                            <ModalBody>
                                <center><EbmsLoading data={isLoading} /></center>
                                {/* <Survey style={defaultCss} model={new SurveyCore.Model(loadedSelectionData["bnf_template"])} data={selectedBnfDetails} /> */}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={toggle}>
                                    CANCEL
                                </Button>{' '}
                                <Button color="primary" onClick={updateBeneficiaryData}>
                                    SAVE CHANGES
                                </Button>
                            </ModalFooter>
                        </Modal>

                        {/* Component Update Response Modal */}
                        <Modal
                            isOpen={showComponentUpdateModal}
                            toggle={() => {
                                setShowComponentUpdateModal(false);
                                setComponentUpdateResponse(null);
                            }}
                            size="lg"
                            centered
                        >
                            <ModalHeader toggle={() => {
                                setShowComponentUpdateModal(false);
                                setComponentUpdateResponse(null);
                            }} className="bg-success text-white">
                                <i className="fas fa-check-circle me-2"></i>
                                Component Update Results
                            </ModalHeader>
                            <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                {componentUpdateResponse && (
                                    <div style={{ padding: '10px' }}>
                                        {/* Success Message */}
                                        <div style={{
                                            padding: '15px',
                                            backgroundColor: '#d4edda',
                                            border: '1px solid #c3e6cb',
                                            borderRadius: '8px',
                                            marginBottom: '20px'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <i className="fas fa-check-circle text-success" style={{ fontSize: '20px' }}></i>
                                                <strong className="text-success">{componentUpdateResponse.message}</strong>
                                            </div>
                                        </div>

                                        {/* Results Table */}
                                        {componentUpdateResponse.data && componentUpdateResponse.data.length > 0 && (
                                            <div>
                                                <h6 style={{ marginBottom: '15px', fontWeight: '600' }}>
                                                    <i className="fas fa-list me-2"></i>
                                                    Update Details
                                                </h6>
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>Beneficiary ID</th>
                                                                <th>Status</th>
                                                               
                                                                <th>Updates</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {componentUpdateResponse.data.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <code style={{ fontSize: '12px' }}>
                                                                            {item.beneficiary_id || 'N/A'}
                                                                        </code>
                                                                    </td>
                                                                    <td>
                                                                        <span className={`badge ${item.status === 'success' ? 'bg-success' : 'bg-danger'}`}>
                                                                            {item.status || 'N/A'}
                                                                        </span>
                                                                    </td>
                                                                  
                                                                    
                                                                    <td>
                                                                        {item.updates ? (
                                                                            <div style={{ fontSize: '12px' }}>
                                                                                <div><strong>Project Beneficiaries:</strong> {item.updates.project_beneficiaries || 0}</div>
                                                                                <div><strong>Children:</strong> {item.updates.project_children_beneficiaries || 0}</div>
                                                                                <div><strong>Clock-ins:</strong> {item.updates.beneficiary_clockins || 0}</div>
                                                                                <div><strong>Entitlements:</strong> {item.updates.beneficiary_entitlement || 0}</div>
                                                                                <div><strong>Cards:</strong> {item.updates.beneficiary_cards_onboarding || 0}</div>
                                                                            </div>
                                                                        ) : 'N/A'}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}

                                        {/* Summary */}
                                        {componentUpdateResponse.data && componentUpdateResponse.data.length > 0 && (
                                            <div style={{
                                                marginTop: '20px',
                                                padding: '15px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6'
                                            }}>
                                                <h6 style={{ marginBottom: '10px', fontWeight: '600' }}>
                                                    <i className="fas fa-chart-bar me-2"></i>
                                                    Summary
                                                </h6>
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
                                                    <div>
                                                        <strong>Total Project Beneficiaries Updated:</strong> {componentUpdateResponse.data.reduce((sum, item) => sum + (item.updates?.project_beneficiaries || 0), 0)}
                                                    </div>
                                                    <div>
                                                        <strong>Total Children Updated:</strong> {componentUpdateResponse.data.reduce((sum, item) => sum + (item.updates?.project_children_beneficiaries || 0), 0)}
                                                    </div>
                                                    <div>
                                                        <strong>Total Clock-ins Updated:</strong> {componentUpdateResponse.data.reduce((sum, item) => sum + (item.updates?.beneficiary_clockins || 0), 0)}
                                                    </div>
                                                    <div>
                                                        <strong>Total Entitlements Updated:</strong> {componentUpdateResponse.data.reduce((sum, item) => sum + (item.updates?.beneficiary_entitlement || 0), 0)}
                                                    </div>
                                                    <div>
                                                        <strong>Total Cards Updated:</strong> {componentUpdateResponse.data.reduce((sum, item) => sum + (item.updates?.beneficiary_cards_onboarding || 0), 0)}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="success"
                                    onClick={() => {
                                        setShowComponentUpdateModal(false);
                                        setComponentUpdateResponse(null);
                                    }}
                                >
                                    <i className="fas fa-check me-2"></i>
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>

                        {/* Edit Beneficiary Basic Details Modal - Batch Update */}
                        <Modal
                            isOpen={editModal}
                            toggle={() => {
                                setEditModal(false);
                                setSelectedBeneficiaries([]);
                                setBeneficiariesFormData({});
                                setUpdateResponse(null);
                                setNotFoundPhones([]);
                            }}
                            className="modal-70w"
                        >
                            <ModalHeader toggle={() => {
                                setEditModal(false);
                                setSelectedBeneficiaries([]);
                                setBeneficiariesFormData({});
                                setUpdateResponse(null);
                                setNotFoundPhones([]);
                            }}>
                                <center>Batch Update Beneficiary Basic Details</center>
                            </ModalHeader>
                            <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <center><EbmsLoading data={isLoading} /></center>
                                <div style={{ padding: '20px' }}>
                                    {/* Excel Upload Button */}
                                    <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                                            Select Beneficiaries *
                                        </label>
                                        <div>
                                            <input
                                                type="file"
                                                accept=".xlsx,.xls"
                                                id="excel-upload-input"
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleExcelUpload(e)}
                                            />
                                            <Button
                                                color="info"
                                                onClick={() => document.getElementById('excel-upload-input').click()}
                                                style={{
                                                    padding: '8px 16px',
                                                    fontSize: '14px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }}
                                            >
                                                <FaIcons.FaFileExcel /> Load from Excel
                                            </Button>
                                        </div>
                                    </div>
                                    
                                    {/* Not Found Phones Note */}
                                    {notFoundPhones.length > 0 && (
                                        <div style={{
                                            marginBottom: '20px',
                                            padding: '12px 15px',
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffc107',
                                            borderRadius: '6px',
                                            borderLeft: '4px solid #ffc107'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: '8px',
                                                fontWeight: 'bold',
                                                color: '#856404',
                                                fontSize: '14px'
                                            }}>
                                                <FaIcons.FaExclamationTriangle style={{ marginRight: '8px' }} />
                                                Phone numbers not found in main list ({notFoundPhones.length}):
                                            </div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: '#856404',
                                                lineHeight: '1.6',
                                                maxHeight: '150px',
                                                overflowY: 'auto'
                                            }}>
                                                {notFoundPhones.map((phone, index) => (
                                                    <span key={index} style={{
                                                        display: 'inline-block',
                                                        margin: '2px 8px 2px 0',
                                                        padding: '2px 8px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ffc107',
                                                        borderRadius: '4px',
                                                        fontSize: '12px'
                                                    }}>
                                                        {phone}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Searchable Dropdown */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <Select
                                            isMulti
                                            isSearchable
                                            value={selectedBeneficiaries.map(ben => ({
                                                value: ben.beneficiary_inst_id,
                                                label: `${ben.name || 'N/A'} (${ben.telephone || 'N/A'})`
                                            }))}
                                            onChange={(selectedOptions) => {
                                                handleBeneficiarySelect(selectedOptions || []);
                                            }}
                                            options={loadedSelectionData?.list_beneficiaries?.map(ben => ({
                                                value: ben.beneficiary_inst_id,
                                                label: `${ben.name || 'N/A'} (${ben.telephone || 'N/A'})`
                                            })) || []}
                                            placeholder="Search and select beneficiaries..."
                                        />
                                    </div>

                                    {/* Beneficiary Rows */}
                                    {selectedBeneficiaries.length > 0 && (
                                        <div style={{ marginTop: '30px' }}>

                                            {/* Component Update Section */}
                                            <div style={{
                                                marginBottom: '25px',
                                                padding: '20px',
                                                border: '1px solid #dee2e6',
                                                borderRadius: '8px',
                                                backgroundColor: '#f8f9fa'
                                            }}>
                                                <h5 style={{ marginBottom: '15px', color: '#495057' }}>
                                                    <i className="fas fa-exchange-alt me-2"></i>
                                                    Update Component
                                                </h5>
                                                <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                                                    <div style={{ flex: '1', minWidth: '300px' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            marginBottom: '8px', 
                                                            fontWeight: '600',
                                                            color: '#495057',
                                                            fontSize: '14px'
                                                        }}>
                                                            Select Component
                                                        </label>
                                                        <Select
                                                            value={selectedComponent ? {
                                                                value: selectedComponent.value,
                                                                label: selectedComponent.text
                                                            } : null}
                                                            onChange={(option) => {
                                                                setSelectedComponent(option ? {
                                                                    value: option.value,
                                                                    text: option.label
                                                                } : null);
                                                            }}
                                                            options={enrollments.map(enrollment => ({
                                                                value: enrollment.value,
                                                                label: enrollment.text
                                                            }))}
                                                            placeholder="Select a component..."
                                                            isSearchable
                                                            isClearable
                                                            styles={{
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    minHeight: '38px'
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <Button
                                                            color="primary"
                                                            onClick={handleUpdateComponent}
                                                            disabled={!selectedComponent || selectedBeneficiaries.length === 0 || isUpdatingComponent}
                                                            style={{ minWidth: '150px' }}
                                                        >
                                                            {isUpdatingComponent ? (
                                                                <>
                                                                    <Spinner size="sm" className="me-2" />
                                                                    Updating...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fas fa-sync me-2"></i>
                                                                    Update Component
                                                                </>
                                                            )}
                                                        </Button>
                                                    </div>
                                                </div>
                                                {selectedBeneficiaries.length > 0 && (
                                                    <div style={{ 
                                                        marginTop: '12px', 
                                                        fontSize: '13px', 
                                                        color: '#6c757d' 
                                                    }}>
                                                        <i className="fas fa-info-circle me-1"></i>
                                                        {selectedBeneficiaries.length} beneficiary{selectedBeneficiaries.length !== 1 ? 'ies' : ''} selected
                                                    </div>
                                                )}
                                            </div>

                                            <h5 style={{ marginBottom: '15px' }}>Edit Beneficiary Details</h5>
                                            {selectedBeneficiaries.map((ben, index) => {
                                                const formData = beneficiariesFormData[ben.beneficiary_inst_id] || {};
                                                return (
                                                    <div key={ben.beneficiary_inst_id} style={{
                                                        marginBottom: '25px',
                                                        padding: '15px',
                                                        border: '1px solid #dee2e6',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#f8f9fa'
                                                    }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                                            <h6 style={{ margin: 0, color: '#495057' }}>
                                                                Beneficiary {index + 1}: {ben.name || 'N/A'}
                                                            </h6>
                                                            <button
                                                                onClick={() => removeBeneficiary(ben.beneficiary_inst_id)}
                                                                style={{
                                                                    padding: '5px 10px',
                                                                    backgroundColor: '#dc3545',
                                                                    color: '#fff',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '12px'
                                                                }}
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                                            <div>
                                                                <label style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontWeight: 'bold', fontSize: '13px' }}>
                                                                    First Name *
                                                                    {isFieldChanged(ben.beneficiary_inst_id, 'first_name') && (
                                                                        <span style={{
                                                                            marginLeft: '8px',
                                                                            padding: '2px 6px',
                                                                            backgroundColor: '#ffc107',
                                                                            color: '#000',
                                                                            borderRadius: '3px',
                                                                            fontSize: '10px',
                                                                            fontWeight: 'bold',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: '4px'
                                                                        }}>
                                                                            CHANGED
                                                                            <span style={{ 
                                                                                fontSize: '9px', 
                                                                                color: '#666',
                                                                                fontStyle: 'italic',
                                                                                fontWeight: 'normal'
                                                                            }}>
                                                                                (was: {getOriginalValue(ben.beneficiary_inst_id, 'first_name') || 'empty'})
                                                                            </span>
                                                                        </span>
                                                                    )}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={formData.first_name || ''}
                                                                    onChange={(e) => updateBeneficiaryField(ben.beneficiary_inst_id, 'first_name', e.target.value)}
                                                                    required
                                                                    style={{
                                                                        border: isFieldChanged(ben.beneficiary_inst_id, 'first_name') ? '2px solid #ffc107' : '1px solid #ced4da',
                                                                        backgroundColor: isFieldChanged(ben.beneficiary_inst_id, 'first_name') ? '#fff9e6' : '#fff'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <label style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontWeight: 'bold', fontSize: '13px' }}>
                                                                    Middle Name
                                                                    {isFieldChanged(ben.beneficiary_inst_id, 'middle_name') && (
                                                                        <span style={{
                                                                            marginLeft: '8px',
                                                                            padding: '2px 6px',
                                                                            backgroundColor: '#ffc107',
                                                                            color: '#000',
                                                                            borderRadius: '3px',
                                                                            fontSize: '10px',
                                                                            fontWeight: 'bold',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: '4px'
                                                                        }}>
                                                                            CHANGED
                                                                            <span style={{ 
                                                                                fontSize: '9px', 
                                                                                color: '#666',
                                                                                fontStyle: 'italic',
                                                                                fontWeight: 'normal'
                                                                            }}>
                                                                                (was: {getOriginalValue(ben.beneficiary_inst_id, 'middle_name') || 'empty'})
                                                                            </span>
                                                                        </span>
                                                                    )}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={formData.middle_name || ''}
                                                                    onChange={(e) => updateBeneficiaryField(ben.beneficiary_inst_id, 'middle_name', e.target.value)}
                                                                    style={{
                                                                        border: isFieldChanged(ben.beneficiary_inst_id, 'middle_name') ? '2px solid #ffc107' : '1px solid #ced4da',
                                                                        backgroundColor: isFieldChanged(ben.beneficiary_inst_id, 'middle_name') ? '#fff9e6' : '#fff'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <label style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontWeight: 'bold', fontSize: '13px' }}>
                                                                    Last Name *
                                                                    {isFieldChanged(ben.beneficiary_inst_id, 'last_name') && (
                                                                        <span style={{
                                                                            marginLeft: '8px',
                                                                            padding: '2px 6px',
                                                                            backgroundColor: '#ffc107',
                                                                            color: '#000',
                                                                            borderRadius: '3px',
                                                                            fontSize: '10px',
                                                                            fontWeight: 'bold',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: '4px'
                                                                        }}>
                                                                            CHANGED
                                                                            <span style={{ 
                                                                                fontSize: '9px', 
                                                                                color: '#666',
                                                                                fontStyle: 'italic',
                                                                                fontWeight: 'normal'
                                                                            }}>
                                                                                (was: {getOriginalValue(ben.beneficiary_inst_id, 'last_name') || 'empty'})
                                                                            </span>
                                                                        </span>
                                                                    )}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={formData.last_name || ''}
                                                                    onChange={(e) => updateBeneficiaryField(ben.beneficiary_inst_id, 'last_name', e.target.value)}
                                                                    required
                                                                    style={{
                                                                        border: isFieldChanged(ben.beneficiary_inst_id, 'last_name') ? '2px solid #ffc107' : '1px solid #ced4da',
                                                                        backgroundColor: isFieldChanged(ben.beneficiary_inst_id, 'last_name') ? '#fff9e6' : '#fff'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <label style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontWeight: 'bold', fontSize: '13px' }}>
                                                                    Telephone *
                                                                    {isFieldChanged(ben.beneficiary_inst_id, 'telephone') && (
                                                                        <span style={{
                                                                            marginLeft: '8px',
                                                                            padding: '2px 6px',
                                                                            backgroundColor: '#ffc107',
                                                                            color: '#000',
                                                                            borderRadius: '3px',
                                                                            fontSize: '10px',
                                                                            fontWeight: 'bold',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: '4px'
                                                                        }}>
                                                                            CHANGED
                                                                            <span style={{ 
                                                                                fontSize: '9px', 
                                                                                color: '#666',
                                                                                fontStyle: 'italic',
                                                                                fontWeight: 'normal'
                                                                            }}>
                                                                                (was: {getOriginalValue(ben.beneficiary_inst_id, 'telephone') || 'empty'})
                                                                            </span>
                                                                        </span>
                                                                    )}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={formData.telephone || ''}
                                                                    onChange={(e) => updateBeneficiaryField(ben.beneficiary_inst_id, 'telephone', e.target.value)}
                                                                    required
                                                                    style={{
                                                                        border: isFieldChanged(ben.beneficiary_inst_id, 'telephone') ? '2px solid #ffc107' : '1px solid #ced4da',
                                                                        backgroundColor: isFieldChanged(ben.beneficiary_inst_id, 'telephone') ? '#fff9e6' : '#fff'
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* API Response Section */}
                                    {updateResponse && (
                                        <div style={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            backgroundColor: updateResponse.status == SUCCESS_RESULT ? '#d4edda' : '#f8d7da',
                                            border: `1px solid ${updateResponse.status == SUCCESS_RESULT ? '#c3e6cb' : '#f5c6cb'}`,
                                            borderRadius: '5px'
                                        }}>
                                            <h5 style={{ marginBottom: '10px', color: updateResponse.status == SUCCESS_RESULT ? '#155724' : '#721c24' }}>
                                                Update Response
                                            </h5>
                                            <div style={{ marginBottom: '8px' }}>
                                                <strong>Status: </strong>
                                                <span style={{
                                                    padding: '3px 8px',
                                                    borderRadius: '3px',
                                                    backgroundColor: updateResponse.status == SUCCESS_RESULT ? '#28a745' : '#dc3545',
                                                    color: '#fff',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {updateResponse.status == SUCCESS_RESULT ? 'Success' : 'Failed'}
                                                </span>
                                            </div>
                                            <div style={{ marginBottom: '8px' }}>
                                                <strong>Message: </strong>
                                                <span style={{ color: updateResponse.status == SUCCESS_RESULT ? '#155724' : '#721c24' }}>
                                                    {updateResponse.message}
                                                </span>
                                            </div>
                                            {updateResponse.data && updateResponse.data.length > 0 && (
                                                <div style={{ marginTop: '15px' }}>
                                                    <strong>Individual Results:</strong>
                                                    {updateResponse.data.map((result, idx) => (
                                                        <div key={idx} style={{
                                                            marginTop: '10px',
                                                            padding: '10px',
                                                            backgroundColor: result.status === 'success' ? '#d1ecf1' : '#f8d7da',
                                                            borderRadius: '4px',
                                                            fontSize: '12px'
                                                        }}>
                                                            <div><strong>Beneficiary ID:</strong> {result.beneficiary_id}</div>
                                                            <div><strong>Status:</strong> <span style={{
                                                                color: result.status === 'success' ? '#155724' : '#721c24',
                                                                fontWeight: 'bold'
                                                            }}>{result.status}</span></div>
                                                            {result.changed !== undefined && (
                                                                <div><strong>Changed:</strong> {result.changed ? 'Yes' : 'No'}</div>
                                                            )}
                                                            <div><strong>Message:</strong> {result.message}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        setEditModal(false);
                                        setSelectedBeneficiaries([]);
                                        setBeneficiariesFormData({});
                                        setUpdateResponse(null);
                                    }}
                                >
                                    {updateResponse ? 'CLOSE' : 'CANCEL'}
                                </Button>
                                {!updateResponse && (
                                    <Button
                                        color="primary"
                                        onClick={updateBeneficiaryBasicDetails}
                                        disabled={isLoading || selectedBeneficiaries.length === 0}
                                    >
                                        {isLoading ? 'UPDATING...' : 'UPDATE'}
                                    </Button>
                                )}
                            </ModalFooter>
                        </Modal>
                        <Alerts.ConfirmationAlert settings={alertSettings} />
                        <div class="modal modal-blur fade" id="deactivateBNF" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <div class="modal-title">Are you sure?</div>
                                        <div>You are about to deactivate &nbsp; <strong>{selectedBeneficiary['name']}</strong>, If you proceed, you will remove the beneficiary from the final listing. Do you wish to proceed?</div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-link link-secondary me-auto" data-bs-dismiss="modal">Cancel</button>
                                        <button type="button" disabled={isLoading} onClick={deactivateBeneficiary} class="btn btn-danger" data-bs-dismiss="modal">Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal modal-blur fade" id="beneficiary-modals" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">BENEFICIARY DETAILS</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        {/* <h2>BEN DATA BELOW</h2> */}
                                        <div class="col-lg-12">
                        <Survey model={selectedBeneficiaryModel} css={surveyCss} data={selectedBeneficiary["beneficiary_details"]} />
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn me-auto" data-bs-dismiss="modal">Close</button>
                                        <button type="button" class="btn btn-primary" onClick={updateBeneficiaryData} data-bs-dismiss="modal">Update changes</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Bulk Deactivate Modal */}
                        {isAdmin() && showBulkDeactivateModal && (
                            <Modal isOpen={showBulkDeactivateModal} toggle={() => setShowBulkDeactivateModal(false)}>
                                <ModalHeader toggle={() => setShowBulkDeactivateModal(false)}>
                                    Confirm Deactivation
                                </ModalHeader>
                                <ModalBody>
                                    <p>You are about to deactivate the following beneficiaries:</p>
                                    <div className="table-responsive">
                                        <table className="table table-sm table-bordered mb-2">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Beneficiary ID</th>
                                                    <th>Status</th>
                                                    <th>Message</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bulkDeactivateResults.map((r, idx) => (
                                                    <tr key={r.beneficiary_inst_id || idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>{r.name}</td>
                                                        <td>{r.beneficiary_inst_id}</td>
                                                        <td>
                                                            <span
                                                                className={`badge ${
                                                                    r.status === "Success"
                                                                        ? "bg-success"
                                                                        : r.status === "Failed"
                                                                        ? "bg-danger"
                                                                        : "bg-secondary"
                                                                }`}
                                                            >
                                                                {r.status}
                                                            </span>
                                                        </td>
                                                        <td style={{ fontSize: "0.8rem" }}>{r.message}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <p className="text-danger mt-2">
                                        Click "Confirm Deactivate" to process. This dialog will stay open so you can
                                        monitor progress and close it manually when done.
                                    </p>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        color="secondary"
                                        onClick={() => setShowBulkDeactivateModal(false)}
                                        disabled={isLoading}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        color="danger"
                                        onClick={bulkDeactivateBeneficiaries}
                                        disabled={isLoading || selectedBeneficiariesForDeactivation.length === 0}
                                    >
                                        {isLoading ? "Processing..." : "Confirm Deactivate"}
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        )}
                        <div class="modal modal-blur fade" id="cycle-modal" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <form class="form-control" onSubmit={getMasterList}>
                                        <div class="modal-body">
                                            <div class="modal-title">COMPONENT CYCLES</div>
                                            <center><EbmsLoading data={isLoading} /></center>
                                            <div><label>Select Distribution cycle</label>
                                                <select class="form-control" required name="cycle" 
                                                onChange={(e)=>setSelected_cycle(e.target.value)}>
                                                    <option class="form-control" value=""> Select Cycle </option>;
                                                    {cycles?.map((c) => {
                                                        return <option value={c.cycle_id}>{c.cycle_name}</option>;
                                                    })}
                                                </select>
                                                MasterList Type
                                                <select class="form-control" required name="masterlist_type" >
                                                    <option class="form-control" value=""> Select Type </option>;
                                                  <option value={10000}>Registration MasterList</option>
                                                  <option value={10001}>Attendance MasterList</option>

                                                     
                                                </select><br/>

Template Type : &nbsp;&nbsp;
                                                <input type="radio" name="template_status"  value={"old"}>
                                                </input>  OLD &nbsp;  
                                                
                                                <input type="radio" name="template_status" checked={true} value={"new"}>
                                                </input> NEW

<br/><br/>
                                                Registration Start Date :<br/>
                                                <input className="form-control" type="date" name="start_date"></input>
 
                                                Registration end Date :<br/>
                                                <input   className="form-control" type="date" name="end_date"></input>

                                                 
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-link link-secondary me-auto" data-bs-dismiss="modal">Cancel</button>
                                            <button type="submit" disabled={isLoading} class="btn btn-info">Get Master List</button>
                                        
                                        </div>

 
{  (global.get_logged_in_user().id == 474 
|| global.get_logged_in_user().id == 712 )
&& <span href="#" onClick={()=>{
    if(selected_cycle=="" || selected_cycle==null || selected_cycle==undefined){
        cogoToast.error("Please select a cycle", {});
        return;
    }
  history.push({
    pathname: "/projects/list-cycles-attendance",
    state: { data: loadedSelectionData["list_beneficiaries"],cycle:selected_cycle }
});
}}>
    Att
    </span> }
                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div> */}

            {/* Masterlist Job Queued Modal */}
            <Modal
                isOpen={showMasterListJobModal}
                toggle={() => setShowMasterListJobModal(false)}
                size="lg"
                backdrop="static"
                zIndex={2000}
            >
                <ModalHeader toggle={() => setShowMasterListJobModal(false)}>
                    Masterlist Export Queued
                </ModalHeader>
                <ModalBody>
                    {masterListJobData ? (
                        <div className="row g-3">
                            <div className="col-md-6">
                                <div className="text-muted small">Job ID</div>
                                <div className="fw-bold mb-2" style={{ wordBreak: "break-word" }}>
                                    {masterListJobData.job_id || "—"}
                                </div>
                                <div className="text-muted small">Queue Job ID</div>
                                <div className="fw-bold mb-2">{masterListJobData.queue_job_id || "—"}</div>
                                <div className="text-muted small">File Name</div>
                                <div className="fw-bold mb-2">{masterListJobData.file_name || "—"}</div>
                                <div className="text-muted small">Status</div>
                                <div className="fw-bold mb-2 text-capitalize">{masterListJobData.status || "—"}</div>
                                <div className="text-muted small">Progress</div>
                                <div className="fw-bold mb-2">{Number(masterListJobData.progress) || 0}%</div>
                            </div>
                            <div className="col-md-6">
                                <div className="text-muted small">Masterlist Type</div>
                                <div className="fw-bold mb-2">
                                    {formatMasterlistJobType(masterListJobData.meta?.masterlist_type)}
                                </div>
                                <div className="text-muted small">Location</div>
                                <div className="fw-bold mb-2">
                                    {formatMasterlistJobLocation(masterListJobData.meta?.location)}
                                </div>
                                <div className="text-muted small">Requested At</div>
                                <div className="fw-bold mb-2">
                                    {formatMasterlistJobDate(masterListJobData.requested_at)}
                                </div>
                                <div className="text-muted small">Expires At</div>
                                <div className="fw-bold mb-2">
                                    {formatMasterlistJobDate(masterListJobData.expires_at)}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-muted">No job details available.</div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowMasterListJobModal(false)}>
                        Close
                    </Button>
                    <Button color="primary" onClick={goToMasterListTracker} disabled={!masterListJobData?.queue_job_id}>
                        Track Job
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Criteria Summary Modal */}
            <Modal isOpen={showCriteriaSummaryModal} toggle={() => setShowCriteriaSummaryModal(false)} size="lg" style={{ maxWidth: '900px' }}>
                <ModalHeader toggle={() => setShowCriteriaSummaryModal(false)}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaIcons.FaClipboardList style={{ fontSize: '20px', color: '#007bff' }} />
                        <span>Criteria Summary</span>
                    </div>
                </ModalHeader>
                <ModalBody style={{ padding: '25px', maxHeight: '70vh', overflow: 'auto' }}>
                    {selectedCriteriaSummary ? (
                        <div>
                            {/* Score and Status Cards */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div style={{
                                        backgroundColor: '#e7f3ff',
                                        padding: '15px',
                                        borderRadius: '8px',
                                        border: '2px solid #007bff',
                                        textAlign: 'center'
                                    }}>
                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Total Score</div>
                                        <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#007bff' }}>
                                            {selectedCriteriaSummary.score || 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div style={{
                                        backgroundColor: selectedCriteriaSummary.can_proceed ? '#d4edda' : '#f8d7da',
                                        padding: '15px',
                                        borderRadius: '8px',
                                        border: `2px solid ${selectedCriteriaSummary.can_proceed ? '#28a745' : '#dc3545'}`,
                                        textAlign: 'center'
                                    }}>
                                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Status</div>
                                        <div style={{ 
                                            fontSize: '20px', 
                                            fontWeight: 'bold', 
                                            color: selectedCriteriaSummary.can_proceed ? '#28a745' : '#dc3545' 
                                        }}>
                                            {selectedCriteriaSummary.can_proceed ? '✓ Can Proceed' : '✗ Cannot Proceed'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Criteria Details using SurveyJS Template */}
                            {(() => {
                                try {
                                    // Get template from row data or loadedSelectionData
                                    const criteriaTemplate = selectedRowData?.selection_criteria_template 
                                        || loadedSelectionData?.selection_criteria_template
                                        || loadedSelectionData?.project?.selection_criteria_template
                                        || loadedSelectionData?.component?.selection_criteria_template;
                                    
                                    console.log('Criteria Template:', criteriaTemplate);
                                    console.log('Selected Criteria Summary:', selectedCriteriaSummary);
                                    console.log('Selected Row Data:', selectedRowData);
                                    console.log('Loaded Selection Data:', loadedSelectionData);
                                    
                                    // Function to create clean JSON array from template and criteria_summary
                                    const createCriteriaBreakdown = (template, summary) => {
                                        if (!template || !summary) return [];
                                        
                                        const breakdown = [];
                                        
                                        // Extract all questions from template
                                        const extractQuestions = (elements, pageTitle = '') => {
                                            if (!elements || !Array.isArray(elements)) return;
                                            
                                            elements.forEach(element => {
                                                if (element.name && element.type && element.title) {
                                                    // Get the value from criteria_summary
                                                    const value = summary[element.name];
                                                    
                                                    if (value !== undefined && value !== null) {
                                                        // Get available choices
                                                        const choices = element.choices || [];
                                                        
                                                        // Find selected choice
                                                        let selectedChoice = null;
                                                        if (choices.length > 0) {
                                                            selectedChoice = choices.find(c => {
                                                                const choiceValue = c.value !== undefined ? c.value : c;
                                                                return String(choiceValue) === String(value);
                                                            });
                                                        }
                                                        
                                                        breakdown.push({
                                                            questionLabel: element.title,
                                                            questionName: element.name,
                                                            pageTitle: pageTitle,
                                                            availableOptions: choices.map(c => ({
                                                                text: c.text || c,
                                                                value: c.value !== undefined ? c.value : c
                                                            })),
                                                            selectedOption: selectedChoice ? {
                                                                text: selectedChoice.text || selectedChoice,
                                                                value: selectedChoice.value !== undefined ? selectedChoice.value : selectedChoice
                                                            } : null,
                                                            selectedValue: value,
                                                            score: value
                                                        });
                                                    }
                                                }
                                                
                                                // Recursively process nested elements
                                                if (element.elements) {
                                                    extractQuestions(element.elements, pageTitle);
                                                }
                                                if (element.questions) {
                                                    extractQuestions(element.questions, pageTitle);
                                                }
                                            });
                                        };
                                        
                                        // Process template pages
                                        if (template.pages && Array.isArray(template.pages)) {
                                            template.pages.forEach(page => {
                                                const pageTitle = page.title || page.name || '';
                                                if (page.elements) {
                                                    extractQuestions(page.elements, pageTitle);
                                                }
                                            });
                                        } else if (template.elements) {
                                            extractQuestions(template.elements);
                                        }
                                        
                                        return breakdown;
                                    };
                                    
                                    const criteriaBreakdown = createCriteriaBreakdown(criteriaTemplate, selectedCriteriaSummary);
                                    console.log('Criteria Breakdown:', criteriaBreakdown);
                                    
                                    // Group breakdown by page title
                                    const groupedByPage = {};
                                    criteriaBreakdown.forEach(item => {
                                        const pageTitle = item.pageTitle || 'Other';
                                        if (!groupedByPage[pageTitle]) {
                                            groupedByPage[pageTitle] = [];
                                        }
                                        groupedByPage[pageTitle].push(item);
                                    });
                                    
                                    if (criteriaBreakdown && criteriaBreakdown.length > 0) {
                                        return (
                                            <div>
                                                <h5 style={{ marginBottom: '20px', color: '#495057', borderBottom: '2px solid #dee2e6', paddingBottom: '10px' }}>
                                                    Criteria Breakdown
                                                </h5>
                                                
                                                {Object.keys(groupedByPage).map((pageTitle, pageIndex) => (
                                                    <div key={pageIndex} style={{ marginBottom: '25px' }}>
                                                        <h6 style={{
                                                            color: '#007bff',
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            marginBottom: '15px',
                                                            padding: '10px 15px',
                                                            backgroundColor: '#e7f3ff',
                                                            borderRadius: '6px',
                                                            borderLeft: '4px solid #007bff'
                                                        }}>
                                                            {pageTitle}
                                                        </h6>
                                                        
                                                        <div style={{
                                                            display: 'grid',
                                                            gap: '12px'
                                                        }}>
                                                            {groupedByPage[pageTitle].map((item, itemIndex) => (
                                                                <div key={itemIndex} style={{
                                                                    backgroundColor: '#ffffff',
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '8px',
                                                                    padding: '15px',
                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                                }}>
                                                                    <div style={{
                                                                        fontWeight: '600',
                                                                        color: '#495057',
                                                                        marginBottom: '12px',
                                                                        fontSize: '14px',
                                                                        lineHeight: '1.5'
                                                                    }}>
                                                                        {item.questionLabel}
                                                                    </div>
                                                                    
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '15px',
                                                                        flexWrap: 'wrap'
                                                                    }}>
                                                                        <div style={{ flex: '1', minWidth: '200px' }}>
                                                                            <div style={{
                                                                        fontSize: '12px',
                                                                        color: '#6c757d',
                                                                        marginBottom: '6px',
                                                                        fontWeight: '500'
                                                                    }}>
                                                                                Selected Answer:
                                                                            </div>
                                                                            <div style={{
                                                                        display: 'inline-block',
                                                                        padding: '6px 12px',
                                                                        backgroundColor: '#d4edda',
                                                                        color: '#155724',
                                                                        borderRadius: '5px',
                                                                        fontWeight: '500',
                                                                        fontSize: '13px',
                                                                        border: '1px solid #c3e6cb'
                                                                    }}>
                                                                                {item.selectedOption ? item.selectedOption.text : `Value: ${item.selectedValue}`}
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '8px'
                                                                        }}>
                                                                            <div style={{
                                                                                fontSize: '12px',
                                                                                color: '#6c757d',
                                                                        fontWeight: '500'
                                                                    }}>
                                                                                Score:
                                                                            </div>
                                                                            <div style={{
                                                                        padding: '6px 14px',
                                                                        backgroundColor: '#007bff',
                                                                        color: '#ffffff',
                                                                        borderRadius: '5px',
                                                                        fontWeight: 'bold',
                                                                        fontSize: '16px',
                                                                        minWidth: '50px',
                                                                        textAlign: 'center',
                                                                        boxShadow: '0 2px 4px rgba(0,123,255,0.2)'
                                                                    }}>
                                                                                {item.score}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    {item.availableOptions && item.availableOptions.length > 0 && (
                                                                        <div style={{
                                                                            marginTop: '12px',
                                                                            paddingTop: '12px',
                                                                            borderTop: '1px solid #e9ecef'
                                                                        }}>
                                                                            <div style={{
                                                                        fontSize: '11px',
                                                                        color: '#6c757d',
                                                                        marginBottom: '6px',
                                                                        fontWeight: '500',
                                                                        textTransform: 'uppercase',
                                                                        letterSpacing: '0.5px'
                                                                    }}>
                                                                                Available Options:
                                                                            </div>
                                                                            <div style={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        gap: '6px'
                                                                    }}>
                                                                                {item.availableOptions.map((option, optIndex) => {
                                                                                    const isSelected = item.selectedOption && 
                                                                                        String(item.selectedOption.value) === String(option.value);
                                                                                    return (
                                                                                        <span key={optIndex} style={{
                                                                                            padding: '4px 10px',
                                                                                            fontSize: '12px',
                                                                                            borderRadius: '4px',
                                                                                            backgroundColor: isSelected ? '#d4edda' : '#f8f9fa',
                                                                                            color: isSelected ? '#155724' : '#495057',
                                                                                            border: `1px solid ${isSelected ? '#c3e6cb' : '#dee2e6'}`,
                                                                                            fontWeight: isSelected ? '600' : '400'
                                                                                        }}>
                                                                                            {option.text} ({option.value})
                                                                                        </span>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    } else {
                                        // Fallback: Display as formatted list if breakdown is empty
                                        return (
                                            <div>
                                                <h5 style={{ marginBottom: '15px', color: '#495057', borderBottom: '2px solid #dee2e6', paddingBottom: '10px' }}>
                                                    Criteria Breakdown
                                                </h5>
                                                {!criteriaTemplate && (
                                                    <div style={{ 
                                                        color: '#856404', 
                                                        padding: '12px', 
                                                        backgroundColor: '#fff3cd', 
                                                        borderRadius: '5px',
                                                        marginBottom: '15px',
                                                        border: '1px solid #ffeaa7',
                                                        fontSize: '13px'
                                                    }}>
                                                        <strong>Note:</strong> Template not found. Showing simplified view.
                                                    </div>
                                                )}
                                                <div style={{
                                                    backgroundColor: '#f8f9fa',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #dee2e6'
                                                }}>
                                                    {Object.keys(selectedCriteriaSummary)
                                                        .filter(key => key !== 'score' && key !== 'can_proceed')
                                                        .map((key, index) => {
                                                            const value = selectedCriteriaSummary[key];
                                                            // Format key name (convert snake_case to Title Case)
                                                            const formattedKey = key
                                                                .split('_')
                                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                .join(' ');
                                                            
                                                            return (
                                                                <div key={index} style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    padding: '12px',
                                                                    marginBottom: '8px',
                                                                    backgroundColor: '#ffffff',
                                                                    borderRadius: '6px',
                                                                    border: '1px solid #e9ecef',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span style={{ fontWeight: '500', color: '#495057' }}>
                                                                        {formattedKey}:
                                                                    </span>
                                                                    <span style={{ 
                                                                        fontSize: '18px', 
                                                                        fontWeight: 'bold', 
                                                                        color: '#007bff',
                                                                        backgroundColor: '#e7f3ff',
                                                                        padding: '4px 12px',
                                                                        borderRadius: '4px'
                                                                    }}>
                                                                        {value}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        );
                                    }
                                } catch (error) {
                                    console.error('Error rendering criteria summary:', error);
                                    console.error('Error Stack:', error.stack);
                                    console.error('Error Details:', {
                                        message: error.message,
                                        name: error.name,
                                        cause: error.cause
                                    });
                                    const errorMessage = error.message || 'Unknown error occurred';
                                    setCriteriaError(errorMessage);
                                    
                                    return (
                                        <div style={{ 
                                            color: '#721c24', 
                                            padding: '15px', 
                                            backgroundColor: '#f8d7da', 
                                            borderRadius: '5px',
                                            border: '1px solid #f5c6cb'
                                        }}>
                                            <strong>Error rendering criteria summary:</strong>
                                            <div style={{ marginTop: '10px', fontSize: '13px', fontFamily: 'monospace' }}>
                                                {errorMessage}
                                            </div>
                                            <div style={{ marginTop: '10px', fontSize: '12px', color: '#856404' }}>
                                                Check browser console (F12) for full error details.
                                            </div>
                                        </div>
                                    );
                                }
                            })()}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
                            <FaIcons.FaExclamationCircle style={{ fontSize: '48px', marginBottom: '15px' }} />
                            <div>No criteria summary available</div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => {
                        setShowCriteriaSummaryModal(false);
                        setSelectedCriteriaSummary(null);
                        setSelectedRowData(null);
                    }}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </div >);
}
export default ViewProject;